export default __webpack_public_path__ + "static/media/product-20.191191d2.webp";